import $ from "jquery";

import {handlerTwitterShareBtn} from './sharing/twitter-share-btn-handler';
import {handlerVkShareBtn} from './sharing/vk-share-btn-handler';
import {handlerFbShareBtn} from './sharing/fb-share-btn-handler';
import {handlerShareBtn} from './sharing/share-btn-handler';

$(() => {
    handlerShareBtn();
    handlerTwitterShareBtn();
    handlerVkShareBtn();
    handlerFbShareBtn();
});
